module.exports = __webpack_public_path__ + "img/oeil.f01c7f95.svg";